<template>
  <div>
    <topsearch title="Excel Yükle"></topsearch>

    <div class="content-section">
      <xls-csv-parser
        :columns="columns"
        v-if="show"
        @on-validate="onValidate"
        help="Excel dosyasını yükledikten sonra sistemdeki alanlarla eşlemeniz gerekecek, yüklediğiniz excel dosyasında veriler satır satır olmalıdır"
        lang="en"
      ></xls-csv-parser>
    </div>
  </div>
</template>

<script>
import { XlsCsvParser } from "../components/Parsers/Excel/index";
import EventBus from "../components/Ui/EventBus";
import http from "../services/http";

export default {
  name: "App",
  components: {
    XlsCsvParser,
  },
  methods: {
    onValidate(results) {
      this.loading = true;

      EventBus.$emit("loadingStatus", { action: "excelUpload", loading: true });

      this.$root.back();

      let totalItems = results.length;

      http
        .bulkInsert({
          inputs: results,
          table: this.$route.params.table,
          excelId: this.excelId,
        })
        .then((e) => {
          this.show = false;

          EventBus.$emit("reflesh");
          EventBus.$emit("bottomMessage", {
            open: true,
            type: "upload",
            total: totalItems,
            count: e.data.successCount,
            title: "Excel yüklendi",
            duration: 5000,
            body:
              " (" +
              e.data.successCount +
              ") tane kayıt başarılı olarak yüklendi",
          });

          EventBus.$emit("loadingStatus", {
            action: "excelUpload",
            success: true,
            loading: false,
          });

          setTimeout(() => {
            //  window.location.reload();
          }, 2200);
        })
        .catch((e) => {
          EventBus.$emit("loadingStatus", {
            action: "excelUpload",
            success: false,
            loading: false,
          });

          this.$root.errorMessage(
            "İşlem başarısız, yaptığınız işlemi tekrar kontrol ediniz"
          );
        })
        .finally((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.excelId = localStorage.excelUploadId;
    EventBus.$on("excelUploadId", (excelUploadId) => {
      this.excelId = excelUploadId;
    });
  },
  created() {
    this.history = this.$route.params.table;
    this.columns = [];
    this.show = true;
    http.fields(this.$route.params.table).then((resp) => {
      this.columns = [];
      this.help = "Zorunlu : ";
      resp.data.map((item) => {
        this.help += " " + item.name;
        this.columns.push({
          name: item.display_name,
          value: item.name,
          isOptional: true,
        });
      });
    });
  },
  data() {
    return {
      excelId: null,
      columns: [],
      messages: [],
      history: null,
      loading: false,
      show: true,
      results: null,
      help: "Required fields : ",
    };
  },
};
</script>

<style></style>
